/* Native article bodies and draft fixtures share the same scoped renderer. */
(() => {
  const initialize = (root) => {
    if (root.dataset.vpJournalReady) return;
    root.dataset.vpJournalReady = 'true';
    const list = root.querySelector('[data-vp-journal-list]');
    const detail = root.querySelector('[data-vp-journal-detail]');
    const filters = root.querySelector('[data-vp-journal-filters]');
    const cards = [...root.querySelectorAll('[data-vp-journal-card]')];
    const makeTablesScrollable = (container) => {
      container.querySelectorAll('.vp-journal-body table').forEach((table) => {
        if (table.parentElement.classList.contains('vp-journal-table-scroll')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'vp-journal-table-scroll';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Planter measurements; scroll horizontally to read all columns');
        table.before(wrapper);
        wrapper.append(table);
      });
    };
    makeTablesScrollable(root);
    if (filters) filters.addEventListener('click', (event) => {
      const button = event.target.closest('[data-vp-journal-filter]');
      if (!button) return;
      const selected = button.dataset.vpJournalFilter;
      filters.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      cards.forEach((card) => { card.hidden = selected !== 'all' && card.dataset.category !== selected; });
    });
    if (!list || !detail || root.dataset.vpJournalMode !== 'preview') return;
    const render = (shouldFocus) => {
      const id = window.location.hash.slice(1);
      const template = /^J0[1-7]$/.test(id) ? root.querySelector(`template[data-vp-journal-article="${id}"]`) : null;
      detail.querySelectorAll('video').forEach((video) => video.pause());
      detail.replaceChildren();
      list.hidden = Boolean(template);
      detail.hidden = !template;
      if (template) {
        detail.append(template.content.cloneNode(true));
        // Safari needs resource selection restarted after inert template content mounts.
        // preload="none" is retained; playback remains an explicit user action.
        detail.querySelectorAll('video').forEach((video) => video.load());
        makeTablesScrollable(detail);
      }
      if (shouldFocus) {
        const heading = (template ? detail : list).querySelector('h1');
        if (heading) {
          heading.tabIndex = -1;
          heading.focus({ preventScroll: true });
          root.scrollIntoView({ block: 'start' });
        }
      }
    };
    window.addEventListener('hashchange', () => render(true));
    render(false);
  };
  const boot = () => document.querySelectorAll('[data-vp-journal]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
